import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    return {
      ...props
    };
  };
};
export default connectCustom(makeMapStateToProps)(Component);
